import { GeoLocation, User, UserDetailedInfo } from "@/types";

import { axios } from "../axios.instance";

export type CompleteOnboardingRequest = Omit<UserDetailedInfo, "locationResidence" | "locationOrigin"> & {
  locationResidence: GeoLocation;
  locationOrigin: GeoLocation;
};

export type CompleteOnboardingResponse = User &
  UserDetailedInfo & {
    inviterCode?: string;
  };

export const completeOnboarding = async (body: CompleteOnboardingRequest): Promise<CompleteOnboardingResponse> => {
  const { data } = await axios.patch("users/complete-onboarding", body);

  return data;
};
